/**
 * Convert pixel to rem
 * @param px - Pixel value in number
 * @returns Rem value in string
 * @example
 * // returns '1rem'
 * pxToRem(16)
 */
export const pxToRem = (px: number): string => `${px / 16}rem`;
